import { LocalStorage } from '~/helpers';

import url from './url';
import request from './request';

const signIn = (data) => request(url.signIn, { method: 'POST', data });

const getMWAccount = () =>
  request(url.MWGetAccount, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${LocalStorage.getToken()}`,
    },
  });

export default {
  signIn,
  getMWAccount,
};
